import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-football-legends',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './football-legends.component.html',
  styleUrl: './football-legends.component.scss'
})
export class FootballLegendsComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.footballLegends;
}
